import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { SearchResult } from '../types/api';

export const useSearch = (query: string, limit: number = 20, offset: number = 0) => {
    return useQuery({
        queryKey: ['search', query, limit, offset],
        queryFn: async () => {
            if (!query || query.trim().length === 0) return [];

            const params = new URLSearchParams();
            params.append('q', query);
            params.append('limit', limit.toString());
            params.append('offset', offset.toString());

            const { data } = await apiClient.get<SearchResult[]>(`/search?${params}`);
            return data;
        },
        enabled: query.trim().length > 0,
    });
};

export const useSearchByYear = (year: number) => {
    return useQuery({
        queryKey: ['search', 'year', year],
        queryFn: async () => {
            const { data } = await apiClient.get<SearchResult[]>(`/search/year?year=${year}`);
            return data;
        },
        enabled: !!year,
    });
};
